import {RouteConfig} from 'vue-router/types/router';

/**
 * Öffentliche Seite der DSGVO-Löschung (ohne Login): Widerruf über den signierten Link der Bestätigungs-Mail (`<id>.<token>`
 * als ein Pfad-Segment) – nur noch für Anträge von vor dem 12.10. (Selbstlöschung im Bewerbungs-Bereich entfällt).
 */
export const applicantDeletionRoutes: RouteConfig[] = [
    {
        path: '/account-deletion/:ref',
        name: 'Löschung stoppen',
        component: () => import(/* webpackChunkName: "applicant-deletion-public" */ '@/views/public/ApplicantDeletionRevokeView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
];
